import { Helmet } from 'react-helmet-async';
import { Box, Container, Typography, Button } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import SchoolIcon from '@mui/icons-material/School';

export default function NotFoundPage() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: (theme) =>
          `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.secondary.main} 100%)`,
      }}
    >
      <Helmet>
        <title>Page Not Found - BrainLoop</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Container maxWidth="sm" sx={{ textAlign: 'center' }}>
        <SchoolIcon sx={{ fontSize: 64, color: (theme) => alpha(theme.palette.primary.contrastText, 0.6), mb: 2 }} />
        <Typography
          variant="h1"
          sx={{ fontWeight: 800, color: 'primary.contrastText', fontSize: { xs: 80, md: 120 }, lineHeight: 1 }}
        >
          404
        </Typography>
        <Typography variant="h5" sx={{ color: (theme) => alpha(theme.palette.primary.contrastText, 0.85), mt: 2, mb: 1, fontWeight: 600 }}>
          Page not found
        </Typography>
        <Typography variant="body1" sx={{ color: (theme) => alpha(theme.palette.primary.contrastText, 0.65), mb: 4 }}>
          The page you're looking for doesn't exist or has been moved.
        </Typography>
        <Button
          component={Link}
          to="/"
          variant="contained"
          size="large"
          sx={{ fontWeight: 700, px: 4, py: 1.5 }}
        >
          Back to Home
        </Button>
      </Container>
    </Box>
  );
}
